export default "__VITE_ASSET__BUhIqz7m__"